// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__HrZ6B","message":"styles_message__DrRm0"};